export const SurveyOptionsListHover = {
  mounted() {
    const hook = this

    // List → Map: dispatch highlight events on card hover
    this.el.addEventListener(
      "mouseenter",
      (e) => {
        const card = e.target.closest("[data-option-id]")
        if (!card) return
        const optionId = card.dataset.optionId
        const id = isNaN(optionId) ? optionId : parseInt(optionId)
        window.dispatchEvent(
          new CustomEvent("survey-modal-map:highlight", {
            detail: { optionId: id },
          }),
        )
      },
      true,
    )

    this.el.addEventListener(
      "mouseleave",
      (e) => {
        const card = e.target.closest("[data-option-id]")
        if (!card) return
        window.dispatchEvent(new CustomEvent("survey-modal-map:unhighlight"))
      },
      true,
    )

    // Map → List: highlight card when map pin hovered
    this.cardHighlightHandler = (e) => {
      const optionId = String(e.detail.optionId)
      const card = hook.el.querySelector(`[data-option-id="${optionId}"]`)
      if (card) {
        const inner = card.querySelector("[data-option-inner]")
        if (inner) {
          inner.classList.remove("border-gray-200")
          inner.classList.add("border-blue-400", "shadow-md", "z-10")
        }
        card.scrollIntoView({ behavior: "smooth", block: "nearest" })
      }
    }
    this.cardUnhighlightHandler = (e) => {
      const optionId = String(e.detail.optionId)
      const card = hook.el.querySelector(`[data-option-id="${optionId}"]`)
      if (card) {
        const inner = card.querySelector("[data-option-inner]")
        if (inner) {
          inner.classList.remove("border-blue-400", "shadow-md", "z-10")
          inner.classList.add("border-gray-200")
        }
      }
    }

    window.addEventListener(
      "survey-modal:highlight-card",
      this.cardHighlightHandler,
    )
    window.addEventListener(
      "survey-modal:unhighlight-card",
      this.cardUnhighlightHandler,
    )
  },

  destroyed() {
    if (this.cardHighlightHandler) {
      window.removeEventListener(
        "survey-modal:highlight-card",
        this.cardHighlightHandler,
      )
    }
    if (this.cardUnhighlightHandler) {
      window.removeEventListener(
        "survey-modal:unhighlight-card",
        this.cardUnhighlightHandler,
      )
    }
  },
}
